import React from "react";

const STEP = 5; // px each shadow shifts to the left
const SIZE = 30; // badge image size in px

export const StackedBadge = ({
  icon,
  label,
  count,
  earned,
  size = SIZE,
  step = STEP,
  maxScreenWidth = null,
}) => {
  const extraLeft = (count - 1) * step;
  const width = Math.min((maxScreenWidth || window.screen.width) * 0.25, size);
  return (
    <div
      style={{
        position: "relative",
        width: width + extraLeft,
        height: width,
        maxWidth: "30vw",
        flexShrink: 0,
        opacity: earned ? 1 : 0.4,
      }}
    >
      {Array.from({ length: count }, (_, i) => (
        <img
          key={i}
          src={icon}
          alt={label}
          width={width}
          height={width}
          style={{
            maxWidth: "25vw",
            position: "absolute",
            top: 0,
            // i=0 is front (rightmost), i=count-1 is back (leftmost)
            left: (count - 1 - i) * step,
            zIndex: count - i,
            transform: `scale(${1 - i * 0.02})`,
            transformOrigin: "center bottom",
            filter: earned ? "none" : "grayscale(100%)",
            objectFit: "contain",
          }}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      ))}
    </div>
  );
};

/**
 * Shows all levels for a single multi-level badge with earned/locked indicators.
 *
 * Props:
 *   badge_key    {string}    Key from BadgeConfig (e.g. 'starts')
 *   config       {object}    The config entry from getBadgeConfig() for this badge
 *   earnedLevels {number[]}  Array of level numbers the user has already earned
 */
export const BadgeLevels = ({ config, earnedLevels = [] }) => {
  if (!config) return null;
  const earnedSet = new Set(earnedLevels);
  const badgeSize = 30;
  const badgeStep = 6;

  return (
    <div style={{ width: "100%" }}>
      {config.levels.map((criteria, idx) => {
        console.log("criteria", criteria, idx);
        const level = idx + 1;
        const earned = earnedSet.has(level);
        return (
          <div
            key={level}
            className="row"
            style={{
              alignItems: "center",
              gap: 8,
              padding: "4px 0",
            }}
          >
            <StackedBadge
              icon={config.icon}
              label={config.label}
              count={level}
              earned={earned}
              size={badgeSize}
              step={badgeStep}
            />

            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>{config.label}</div>
              <div style={{ fontSize: 12, color: "#888" }}>{criteria}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
